<template>
  <div>
    <b-tabs content-class="" nav-class="ml-1">
      <b-tab :title="$t('routes.EXABOrganizationLeadList')">
        <b-card>
          <OrganizationLeadList
            :addNoteToOrganizationLeadModal="addNoteToOrganizationLead"
            :addPhoneToOrganizationLeadModal="addPhoneToOrganizationLead"
            :addMeetingToOrganizationLeadModal="addMeetingToOrganizationLead"
          />
        </b-card>
      </b-tab>
      <b-tab :title="$t('routes.EXABOrganizationLeadKanbanBoard')">
        <b-card>
          <OrganizationLeadKanbanBoard
            :addNoteToOrganizationLeadModal="addNoteToOrganizationLead"
            :addPhoneToOrganizationLeadModal="addPhoneToOrganizationLead"
            :addMeetingToOrganizationLeadModal="addMeetingToOrganizationLead"
          />
        </b-card>
      </b-tab>
      <b-tab :title="$t('views.exaborganizationlead.list.salesFunnel')">
        <b-card>
          <OrganizationLeadFunnel />
        </b-card>
      </b-tab>
    </b-tabs>
    <PhoneCreateModal
      :id-organization-lead="idOrganizationLeadToCreateRelation"
    ></PhoneCreateModal>
    <MeetingCreateModal
      :id-organization-lead="idOrganizationLeadToCreateRelation"
    ></MeetingCreateModal>
    <AddNoteModal
      :id-organization-lead="idOrganizationLeadToCreateRelation"
    ></AddNoteModal>
  </div>
</template>

<script>
import OrganizationLeadList from '@/components/Dashboard/Views/AgreementsBundle/exaborganizationlead/OrganizationLeadList.vue'
import OrganizationLeadKanbanBoard from '@/components/Dashboard/Views/AgreementsBundle/exaborganizationlead/OrganizationLeadKanbanBoard.vue'
import PhoneCreateModal from '@/components/Dashboard/Views/excmrelation/modals/PhoneCreateModal.vue'
import AddNoteModal from '@/components/Dashboard/Views/excmnote/modals/CreateNoteModal.vue'
import MeetingCreateModal from '@/components/Dashboard/Views/excmrelation/modals/MeetingCreateModal.vue'
import { mapMutations } from 'vuex'
import OrganizationLeadFunnel from '@/components/Dashboard/Views/AgreementsBundle/exaborganizationlead/OrganizationLeadFunnel.vue'

export default {
  components: {
    OrganizationLeadFunnel,
    MeetingCreateModal,
    AddNoteModal,
    PhoneCreateModal,
    OrganizationLeadKanbanBoard,
    OrganizationLeadList
  },
  data () {
    return {
      idOrganizationLeadToCreateRelation: null
    }
  },
  methods: {
    ...mapMutations({
      toggleAddNoteModal: 'excmnote/createModal/toggleModal',
      toggleMeetingModal: 'excmrelation/createModal/toggleMeetingModal',
      togglePhoneModal: 'excmrelation/createModal/togglePhoneModal'
    }),
    addNoteToOrganizationLead (idOrganizationLead) {
      this.idOrganizationLeadToCreateRelation = idOrganizationLead
      this.toggleAddNoteModal()
    },
    addPhoneToOrganizationLead (idOrganizationLead) {
      this.idOrganizationLeadToCreateRelation = idOrganizationLead
      this.togglePhoneModal()
    },
    addMeetingToOrganizationLead (idOrganizationLead) {
      this.idOrganizationLeadToCreateRelation = idOrganizationLead
      this.toggleMeetingModal()
    }
  }
}
</script>
